function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg61520Fa346E5A67B68Fd5039JustairLogoFullColorRgb2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 704.5883 183.0467",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "type"
  }, /*#__PURE__*/React.createElement("path", {
    id: "type_CompoundPathItem_",
    "data-name": "type <CompoundPathItem>",
    d: "M263.8071,124.6932a30.6584,30.6584,0,0,1-6.4094,10.8217,25.5478,25.5478,0,0,1-9.7817,6.4747,35.0011,35.0011,0,0,1-12.3838,2.1365q-11.2459,0-18.65-4.9822a40.6078,40.6078,0,0,1-12.1009-12.671l8.1151-6.9751a38.0665,38.0665,0,0,0,9.7512,10.6041q5.1955,3.6289,13.0278,3.6333a18.135,18.135,0,0,0,13.95-6.0526q5.5545-6.0506,5.5523-17.8664V43.05h11.2481v66.6226A44.5167,44.5167,0,0,1,263.8071,124.6932Z",
    style: {
      fill: "#29abe2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "type_CompoundPathItem_2",
    "data-name": "type <CompoundPathItem>",
    d: "M343.2834,69.1012h10.8173v73.602H343.2834V129.8887a34.6843,34.6843,0,0,1-9.6816,10.1776q-5.9787,4.2034-15.5167,4.2034a31.0588,31.0588,0,0,1-11.8877-2.1365,24.5416,24.5416,0,0,1-8.8244-6.0526,26.4891,26.4891,0,0,1-5.5523-9.3248,35.4218,35.4218,0,0,1-1.9233-11.9574V69.1012h10.9609v42.9951q0,10.2473,5.2695,16.2259,5.2607,5.9787,15.09,5.9787a23.1777,23.1777,0,0,0,8.7548-1.6361,19.6481,19.6481,0,0,0,6.9751-4.695,22.7572,22.7572,0,0,0,4.6254-7.332,25.0852,25.0852,0,0,0,1.71-9.3987Z",
    style: {
      fill: "#29abe2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "type_CompoundPathItem_3",
    "data-name": "type <CompoundPathItem>",
    d: "M427.2067,131.3855a21.3776,21.3776,0,0,1-5.5522,6.9055,24.5032,24.5032,0,0,1-8.2588,4.3383,34.3454,34.3454,0,0,1-10.3212,1.4968,47.2975,47.2975,0,0,1-16.0868-2.92,50.0471,50.0471,0,0,1-14.3766-7.902l5.5522-7.8279a48.4679,48.4679,0,0,0,12.4578,6.9751,36.9407,36.9407,0,0,0,13.0234,2.4193q6.69,0,10.9609-3.1286a10.0231,10.0231,0,0,0,4.2729-8.5416v-.2871a7.6262,7.6262,0,0,0-1.4968-4.6994,13.4179,13.4179,0,0,0-4.0554-3.4854,32.5048,32.5048,0,0,0-5.9091-2.6325q-3.3483-1.1423-6.9054-2.1365-4.2687-1.2794-8.6112-2.7761a35.0858,35.0858,0,0,1-7.828-3.7726,19.1112,19.1112,0,0,1-5.6959-5.6958,15.4071,15.4071,0,0,1-2.2061-8.5416v-.2829a19.88,19.88,0,0,1,1.8493-8.6155,19.34,19.34,0,0,1,5.1955-6.6879,23.6933,23.6933,0,0,1,7.9715-4.273,32.49,32.49,0,0,1,10.0385-1.4925,45.6249,45.6249,0,0,1,13.811,2.2061,51.9082,51.9082,0,0,1,12.6666,5.9047l-4.9823,8.2587a49.9276,49.9276,0,0,0-10.7477-5.1954,33.9382,33.9382,0,0,0-11.0305-1.9233q-6.553,0-10.3952,3.0633a9.3687,9.3687,0,0,0-3.8422,7.6148v.2828a6.86,6.86,0,0,0,1.5665,4.4862,13.709,13.709,0,0,0,4.199,3.3462,38.2459,38.2459,0,0,0,6.0483,2.5629q3.42,1.1421,7.1187,2.2757,4.2751,1.2858,8.4719,2.85a33.0827,33.0827,0,0,1,7.6148,3.9858,19.4669,19.4669,0,0,1,5.4826,5.835,15.987,15.987,0,0,1,2.0625,8.398v.2872A20.3043,20.3043,0,0,1,427.2067,131.3855Z",
    style: {
      fill: "#29abe2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "type_CompoundPathItem_4",
    "data-name": "type <CompoundPathItem>",
    d: "M463.0091,121.7735q0,6.8337,3.4158,9.5381a14.025,14.025,0,0,0,8.9723,2.7065,23.748,23.748,0,0,0,5.3391-.57,24.0159,24.0159,0,0,0,5.3346-1.9929V140.85a24.2448,24.2448,0,0,1-6.0483,2.35,30.3435,30.3435,0,0,1-7.1883.7832,28.8574,28.8574,0,0,1-8.2587-1.14,16.915,16.915,0,0,1-6.6183-3.629,16.7171,16.7171,0,0,1-4.3426-6.4747,26.0856,26.0856,0,0,1-1.5665-9.5381V78.7828H441.7966V69.1012h10.2516V46.8922h10.9609v22.209h23.349v9.6816h-23.349Z",
    style: {
      fill: "#29abe2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "type_CompoundPathItem_5",
    "data-name": "type <CompoundPathItem>",
    d: "M579.6019,142.7032,570.49,120.3507H528.3524l-9.1116,22.3525H496.8882L539.5961,42.3364h20.2161L602.52,142.7032ZM549.4214,68.6748l-13.241,32.317H562.658Z",
    style: {
      fill: "#29abe2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "type_CompoundPathItem_6",
    "data-name": "type <CompoundPathItem>",
    d: "M616.0439,57.9967V38.777h22.779v19.22Zm.57,84.7065V66.3947h21.639v76.3085Z",
    style: {
      fill: "#29abe2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "type_CompoundPathItem_7",
    "data-name": "type <CompoundPathItem>",
    d: "M703.4526,87.6072q-10.8216,0-17.0135,6.5487-6.1941,6.5531-6.1919,20.36v28.1876h-21.639V66.3947h21.639V81.7721a31.7127,31.7127,0,0,1,8.968-12.5273q5.6915-4.6995,15.3731-4.273V87.6072Z",
    style: {
      fill: "#29abe2"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "logoMark"
  }, /*#__PURE__*/React.createElement("path", {
    id: "logoMark_PathItem_",
    "data-name": "logoMark <PathItem>",
    d: "M104.62,181.8386a89.2246,89.2246,0,0,0,17.0036-4.5611,171.33,171.33,0,0,1,13.3375-15.006,169.5334,169.5334,0,0,1,33.9892-26.319,89.3376,89.3376,0,0,0,6.8185-16.1981A181.58,181.58,0,0,0,104.62,181.8386Z",
    style: {
      fill: "#22b573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "logoMark_PathItem_2",
    "data-name": "logoMark <PathItem>",
    d: "M89.8908,168.2687v14.778h0c1.21,0,2.4134-.031,3.6123-.0784a190.0311,190.0311,0,0,1,84.8924-74.0852,90.2034,90.2034,0,0,0,1.31-12.549,199.0159,199.0159,0,0,0-66.5824,44.1A201.6644,201.6644,0,0,0,89.8908,168.2687Z",
    style: {
      fill: "#22b573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "logoMark_PathItem_3",
    "data-name": "logoMark <PathItem>",
    d: "M89.8908,152.4852v.9985a211.5867,211.5867,0,0,1,17.0406-19.2419,208.3539,208.3539,0,0,1,58.123-41.071H141.7259a219.2086,219.2086,0,0,0-42.618,33.2481q-4.7783,4.7783-9.2171,9.8122v16.2541Z",
    style: {
      fill: "#22b573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "logoMark_PathItem_4",
    "data-name": "logoMark <PathItem>",
    d: "M125.4727,93.158a232.0072,232.0072,0,0,0-32.5716,27.0908c-1.0247.98-2.0049,2.05-3.03,3.0745V107.7282q8.1539-7.6861,16.8874-14.57Z",
    style: {
      fill: "#22b573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "logoMark_PathItem_5",
    "data-name": "logoMark <PathItem>",
    d: "M89.8715,98.7722v13.6345a37.6446,37.6446,0,0,1-6.55-4.7231c-3.3864-2.8071-5.7926-4.8565-11.0947-4.8565-5.3466,0-7.7529,2.0494-11.1393,4.8565-3.92,3.3418-8.8668,7.441-18.18,7.441-9.3564,0-14.2581-4.0992-18.2232-7.441-3.3418-2.8071-5.7927-4.8565-11.0958-4.8565s-7.7518,2.0494-11.0936,4.8565c-.3568.312-.7582.6685-1.16.98A96.1228,96.1228,0,0,1,.0446,95.6531L0,93.158H22.1448a31.8672,31.8672,0,0,1,9.6686,6.06c3.3417,2.8069,5.7926,4.8566,11.0947,4.8566s7.7083-2.05,11.0947-4.8566a31.3133,31.3133,0,0,1,9.67-6.06H80.7371A29.0382,29.0382,0,0,1,89.8715,98.7722Z",
    style: {
      fill: "#29abe2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "logoMark_PathItem_6",
    "data-name": "logoMark <PathItem>",
    d: "M8.1919,130.6671a13.7613,13.7613,0,0,1,5.401-.9694c5.3133,0,7.7389,2.0354,11.0972,4.8526,3.9508,3.3148,8.8686,7.44,18.2077,7.44s14.2581-4.1255,18.21-7.44c3.3583-2.8172,5.7851-4.8526,11.099-4.8526s7.7413,2.0354,11.1,4.8529a37.39,37.39,0,0,0,6.5848,4.6973V125.6347c-3.8665-3.2289-8.7515-7.0007-17.6845-7.0007-9.34,0-14.2581,4.1255-18.2095,7.44-3.3583,2.8173-5.7851,4.8527-11.099,4.8527s-7.7389-2.0354-11.0972-4.8527c-3.9508-3.3148-8.8686-7.44-18.2077-7.44A24.8259,24.8259,0,0,0,4.2,120.3425,89.2535,89.2535,0,0,0,8.1919,130.6671Z",
    style: {
      fill: "#29abe2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "logoMark_PathItem_7",
    "data-name": "logoMark <PathItem>",
    d: "M89.8908,152.4852c-3.8665-3.2288-8.7515-7.0006-17.6845-7.0006-9.34,0-14.2581,4.1255-18.2095,7.44-3.3583,2.8172-5.7851,4.8526-11.099,4.8526s-7.7389-2.0354-11.0972-4.8526c-3.4489-2.8937-7.636-6.4038-14.8565-7.2493a90.3952,90.3952,0,0,0,17.4584,18.2019q.849.6671,1.7141,1.3141,2.53,1.8918,5.1945,3.6055c.5154.0271,1.042.0441,1.5867.0441,9.34,0,14.2581-4.1255,18.21-7.44,3.3583-2.8173,5.7851-4.8527,11.099-4.8527s7.7413,2.0354,11.1,4.853a37.4,37.4,0,0,0,6.5848,4.6973V152.4852Z",
    style: {
      fill: "#29abe2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "logoMark_PathItem_8",
    "data-name": "logoMark <PathItem>",
    d: "M72.2063,172.3348a23.8535,23.8535,0,0,0-14.7327,4.6824,89.6468,89.6468,0,0,0,32.4171,6.0295h0v-3.7112C86.0243,176.1066,81.1393,172.3348,72.2063,172.3348Z",
    style: {
      fill: "#29abe2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "logoMark_PathItem_9",
    "data-name": "logoMark <PathItem>",
    d: "M89.8715,3.2862v11.05A78.8779,78.8779,0,0,0,11.0947,93.158H0A90.4133,90.4133,0,0,1,3.1188,69.7208l.6679-2.406c.1784-.5346.3568-1.0693.4906-1.604.3122-.9358.6233-1.9159.98-2.8071.4015-1.2031.8464-2.3616,1.337-3.52.4-1.025.8017-1.9605,1.2477-2.9409.4895-1.0694.98-2.1387,1.5143-3.208.669-1.337,1.3815-2.6736,2.094-3.9657.669-1.1585,1.3369-2.2724,2.006-3.3864a86.66,86.66,0,0,1,5.4358-7.7975c.1784-.2673.3557-.49.5341-.7128A93.02,93.02,0,0,1,34.398,22.4457c.5787-.4455,1.1586-.8466,1.7373-1.2921A89.2843,89.2843,0,0,1,89.8715,3.2862Z",
    style: {
      fill: "#e4af60"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "logoMark_PathItem_10",
    "data-name": "logoMark <PathItem>",
    d: "M89.8715,22.223v11.05A59.938,59.938,0,0,0,29.9869,93.158h-11.05A70.9482,70.9482,0,0,1,89.8715,22.223Z",
    style: {
      fill: "#e4af60"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "logoMark_PathItem_11",
    "data-name": "logoMark <PathItem>",
    d: "M37.87,93.1708H48.9339A40.9733,40.9733,0,0,1,89.8908,52.214V41.15A52.02,52.02,0,0,0,37.87,93.1708Z",
    style: {
      fill: "#e4af60"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "logoMark_PathItem_12",
    "data-name": "logoMark <PathItem>",
    d: "M89.8715,60.0966v11.05A22.0587,22.0587,0,0,0,67.8605,93.158H56.81A33.0492,33.0492,0,0,1,89.8715,60.0966Z",
    style: {
      fill: "#e4af60"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "logoMark_PathItem_13",
    "data-name": "logoMark <PathItem>",
    d: "M126.3963,11.0267c-7.96,1.9853-14.8438,5.034-19.8531,10.05A47.87,47.87,0,0,0,92.351,50.4686a39.3878,39.3878,0,0,0,0,6.9147,34.2679,34.2679,0,0,0,4.2288,13.86c9.0661-14.2352,46.0616-34.4694,46.83-34.8873C117.6007,54.82,109.1985,65.73,92.351,89.6768c-.3258.461-.6576.922-.9895,1.3953h6.804a54.18,54.18,0,0,1,7.64-9.6623c14.7761,10.4859,37.3151,7.3758,52.878-8.187,4.6835-4.6775,8.3837-12.293,11.2848-20.8919C177.6578,29.5829,179.766,0,179.766,0s-11.5922,6.0419-30.1116,7.6339A152.3553,152.3553,0,0,0,126.3963,11.0267Z",
    style: {
      fill: "#8cc63f"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg61520Fa346E5A67B68Fd5039JustairLogoFullColorRgb2);
export default __webpack_public_path__ + "static/media/61520fa346e5a67b68fd5039_justair-logo-full-color-rgb-2.5ed765f398eed3986c6bd15f00a88880.svg";
export { ForwardRef as ReactComponent };